export default __webpack_public_path__ + "static/google-cloud-translation-e81ab3c1cc26f2c0e628052d2350f872.png";